import { defineStore } from 'pinia'
import { useTokenStore } from './token'



export const useGlobalStore = defineStore({
  id: 'global-store',
  state: () => {

    return {
      apiBase: window.location.hostname == "localhost" ? "http://localhost:3030/api/" : "https://" + window.location.hostname + "/api/",
      damUrl: window.location.hostname == "devismaison.dev.cloudh.io"
        ? "https://tst-dam.hermes.com"
        : (window.location.hostname == "devismaison.rct.cloudh.io"
          ? "https://ppd-dam.hermes.com"
          : "https://prd-dam.hermes.com"
        ),

      language: localStorage.getItem("myquote-language") || "fr", // Si aucune langue n'est trouvée, utilisez "fr" par défaut
      currencies: {},
      parameters: {},
      countries: {},
      stores: {},
      users: {},
      logs: {},
      user: null,

      //store: null,
      //country: null,
      //locale: "fr-FR",
      //currency: "EUR",

      isPrintingToPdf: false
    }
  },
  actions: {
    updateLanguage(value: string) {
      this.language = value;
      localStorage.setItem("myquote-language", value);
    },

    /*updateCurrency(value: string) {
      this.currency = value;
    },*/
    async updateUser(value: object) {
      this.user = value;
      if (this.user && this.user.id) {
        await this.fetchStores()
        await this.fetchCountries()
        await this.fetchUsers()
        await this.fetchCurrencies()
        await this.fetchParameters()

        /*
        if (this.user && this.user.store_id) {
          this.store = this.stores.data.find(it => it.id == this.user.store_id)
        }
        if (this.user && this.user.country_id) {
          this.country = this.countries.data.find(it => it.id == this.user.country_id)
        }
        if (this.country && this.country.currency) {
          this.currency = this.currencies.data.find(it => it.id == this.country.currency)
        }
        */

      }

    },


    async fetchParameters(force = true) {
      if (force || !this.parameters.hasOwnProperty("data")) {
        const { data } = await useNuxtApp().$get('/parameters')

        this.parameters = data
        this.parameters["labels"] = {}
        console.log(data.value.data)

        data.value.data.forEach(param => {
          this.parameters.labels[param.key] = { "fr": param.fr, "en": param.en }
        });
      }
    },

    async fetchCurrencies(force = true) {
      if (force || !this.currencies.hasOwnProperty("data")) {

        const tokenStore = useTokenStore();

        const { data: currs } = await useFetch('/currency', {
          method: 'GET',
          headers: { "Authorization": "Bearer " + tokenStore.currentValue },
          baseURL: this.apiBase,
          /*transform: (currs) => {
            currs.data.map((curr) => {
                return curr
              })
              return currs

          }*/
        }
        )
        this.currencies = currs
      }
    },

    async fetchUsers(force = true) {
      if (force || !this.users.hasOwnProperty("data")) {
        const { data } = await useNuxtApp().$get('/users')

        this.users = data
      }
    },

    async fetchCountries(force = true) {
      if (force || !this.countries.hasOwnProperty("data")) {
        const tokenStore = useTokenStore();
        const { data, error } = await useFetch('/country', {
          method: 'GET',
          headers: { "Authorization": "Bearer " + tokenStore.currentValue },
          baseURL: this.apiBase,
          transform: (countries: any) => {
            countries.data.map((country: any) => {
              let sr = null
              try {
                sr = JSON.parse(country.shipping_rates)
              } catch (e) {
                console.log(e)
              }
              country.shipping_rates = sr ? sr : {}

              let sp = null
              try {
                sp = JSON.parse(country.specific_params)
              } catch (e) {
                console.log(e)
              }
              country.specific_params = sp ? sp : { 'fr': "", 'en': "" }
              console.log("country.specific_params")
              console.log(country.specific_params)

              let splth = null
              try {
                splth = JSON.parse(country.specific_params_lth)
              } catch (e) {
                console.log(e)
              }
              country.specific_params_lth = splth ? splth : { 'fr': "", 'en': "" }
              console.log("country.specific_params_lth")
              console.log(country.specific_params_lth)

              return country
            })
            return countries
          }
        })
        this.countries = data
      }
    },

    async fetchStores(force = true) {
      if (force || !this.stores.hasOwnProperty("data")) {

        const tokenStore = useTokenStore();

        const { data, error } = await useFetch('/store', {
          method: 'GET',
          headers: { "Authorization": "Bearer " + tokenStore.currentValue },
          baseURL: this.apiBase,
          transform: (stores: any) => {
            stores.data.map((store: any) => {
              if (store.bank_information) {
                let bi = JSON.parse(store.bank_information)
                if (bi) {
                  Object.keys(bi).forEach(k => {
                    store[k] = bi[k]
                  })
                }
              }
              let ac = null
              try {
                ac = JSON.parse(store.additional_comments);
              } catch (e) {
                console.log(e)
              }
              store.additional_comments = ac ? ac : { 'fr': "", 'en': "" }

              return store
            })
            return stores
          }
        }
        )
        this.stores = data
      }

    },

    getStoreName(id: number) {
      let name = "";
      if (this.stores && this.stores.data) {
        const c = this.stores.data.find((it: any) => it.id == id)
        name = (c && c.iso_code) ? c.iso_code : ""
      }
      return name;
    },


    async fetchLogs(force = true) {
      if (force || !this.logs.hasOwnProperty("data")) {
        const { data } = await useNuxtApp().$get('/upload')

        this.logs = data
      }
    },



  },
  getters: {
    //language: state => state.language,
    //currency: state => state.currency
    //getCurrency: state => state.currency

    getCountryNameById: (state) => {
      return (id: number) => {
        let name = "";
        if (state.countries && state.countries.data) {
          const c = state.countries.data.find((it: any) => it.id == id)
          name = (c && c.name) ? c.name : ""
        }
        return name;
      }
    },

    getStoreNameById: (state) => {
      return (id: number) => {
        let name = "";
        if (state.stores && state.stores.data) {
          const c = state.stores.data.find((it: any) => it.id == id)
          name = (c && c.name) ? c.name : ""
        }
        return name;
      }
    },

    getCurrencyCodeById: (state) => {
      return (id: number) => {
        let name = "";
        if (state.currencies && state.currencies.data) {
          const c = state.currencies.data.find((it: any) => it.id == id)
          name = (c && c.iso_code) ? c.iso_code : ""
        }
        return name;
      }
    },
  }
})
